import {Injectable} from "@angular/core";
import {AbstractControl, ValidationErrors, ValidatorFn} from "@angular/forms";

@Injectable({
	providedIn: "root",
})
export class CustomValidationService {
	passwordValidator(): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			if (!control.value) {
				return null;
			}
			const regexForLength = new RegExp("^.{6,}$");
			const regexForLowerCaseChars = new RegExp(".*[a-z].*");
			const regexForUpperCaseChars = new RegExp(".*[A-Z].*");
			const regexForNumbers = new RegExp(".*\\d.*");

			if (!regexForLength.test(control.value)) {
				return {invalidPwdLength: true};
			}

			if (!regexForLowerCaseChars.test(control.value)) {
				return {noLowerCaseChar: true};
			}

			if (!regexForUpperCaseChars.test(control.value)) {
				return {noUpperCaseChar: true};
			}

			if (!regexForNumbers.test(control.value)) {
				return {noNumbers: true};
			}

			return null;
		};
	}

	matchPassword(password: string, confirmPassword: string): ValidatorFn {
		return (formGroup: AbstractControl) => {
			const passwordControl = formGroup.get(password);
			const confirmPasswordControl = formGroup.get(confirmPassword);

			if (!passwordControl || !confirmPasswordControl) {
				return null;
			}

			if (confirmPasswordControl.errors && !confirmPasswordControl.errors.passwordMismatch) {
				return null;
			}

			if (passwordControl.value !== confirmPasswordControl.value && confirmPasswordControl.value.length >= 1) {
				confirmPasswordControl.setErrors({passwordMismatch: true});
			} else {
				confirmPasswordControl.setErrors(null);
			}

			return null;
		};
	}

	noSpacesValidator(): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			if (control && control.value?.indexOf(" ") >= 0) {
				return {spaceNotAllowed: true};
			}
			return null;
		};
	}
}
